export function fetchDownloadCreativeErrorLogs(state, { page, sort, filter }) {
  return {
    ...state,
    downloadCreativeErrorLogs: {
      ...state.downloadCreativeErrorLogs,
      currentPage: page,
      sort: sort || state.downloadCreativeErrorLogs.sort,
      filter: filter || state.downloadCreativeErrorLogs.filter,
    },
  };
}

export function fetchDownloadCreativeErrorLogsSuccess(state, downloadCreativeErrorLogs) {
  return {
    ...state,
    downloadCreativeErrorLogs: {
      ...state.downloadCreativeErrorLogs,
      numberOfPages: downloadCreativeErrorLogs.numberOfPages,
      count: downloadCreativeErrorLogs.count,
      items: downloadCreativeErrorLogs.items,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/downloadCreativeErrorLogs.js
 **/